import { CommonModule } from '@angular/common';
import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  input,
  output,
  computed,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

import { SelectableTopic } from '../../../extract/constans/default-topics';
import { UserEntityIconsComponent } from '../../../shared/components/user-entity-icons/user-entity-icons.component';
import { FastTooltipDirective } from '../../../shared/directives/fast-tooltip.directive';
import { PermissionsDirective } from '../../../shared/directives/permissions.directive';
import { SemerisTooltipDirective } from '../../../shared/directives/semeris-tooltip.directive';
import { StopPropagationDirective } from '../../../shared/directives/stop-propagation.directive';
import { Permission } from '../../../shared/models/api/permissions.enum';
import { UserTemplateEntityBase } from '../../../shared/models/common/user-template-entity-base.model';
import { BoldSpanPipe } from '../../../shared/pipes/bold-span.pipe';
import { SafeHtmlPipe } from '../../../shared/pipes/safe-html.pipe';
import { SearchResultType, UnifiedSearchResult } from '../../models/search.model';

@Component({
  imports: [
    CommonModule,
    MatIconModule,
    RouterModule,
    FastTooltipDirective,
    StopPropagationDirective,
    BoldSpanPipe,
    SafeHtmlPipe,
    SemerisTooltipDirective,
    UserEntityIconsComponent,
    PermissionsDirective,
  ],
  selector: 'semeris-search-result-item',
  templateUrl: './search-result-item.component.html',
  styleUrls: ['./search-result-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultItemComponent {
  public readonly item = input.required<UnifiedSearchResult>();
  public readonly term = input<string>(undefined);

  public readonly marketCompare = output<UnifiedSearchResult>();
  public readonly formula = output();
  public readonly toggle = output();
  public readonly close = output();

  public Permissions = Permission;

  public readonly isBuiltIn = computed<boolean>(
    () => this.item()?.type === SearchResultType.BuiltInTopic
  );
  public readonly isAdd = computed<boolean>(
    () => !(this.item()?.item as SelectableTopic)?.inMyTopics
  );
  public readonly shouldDisplayType = computed<boolean>(() => {
    const itemType = this.item().displayType || this.item().type;
    return (
      itemType &&
      itemType !== SearchResultType.Manager &&
      itemType !== SearchResultType.Topic &&
      itemType !== SearchResultType.DefinedTerm &&
      itemType !== SearchResultType.Checklist
    );
  });

  public readonly isRouterLinkEnabled = computed<boolean>(() => {
    const item = this.item();
    const itemAsEntityBase = this.itemAsEntityBase();
    return item?.routerLinkEdit && (!itemAsEntityBase?.template || itemAsEntityBase?.myTenant);
  });

  public readonly itemAsEntityBase = computed<UserTemplateEntityBase>(
    () => this.item()?.item as UserTemplateEntityBase
  );

  public onToggle() {
    this.toggle.emit();
  }

  public onClick(event: MouseEvent) {
    event.stopPropagation();
    this.close.emit();
  }

  public onMarketCompare(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.marketCompare.emit(this.item());
  }

  public onFormulaClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.formula.emit();
  }
}
